<template lang="pug">
.general
  .entity-content.pa-5
    v-row.primaryHover--text
      v-col.d-flex.align-center(cols="2")
        h2.primary--text {{ $tc('Quote._name', 1)}}
      v-col.d-flex.align-center.quote-header(cols="3")
        span.header-text {{ `${$t('Quote.total')}:` }} &nbsp;
        span {{quoteTotal}}
      v-col.d-flex.align-center.quote-header(cols="3")
        span.header-text {{ `${$t('Quote.items')}:` }} &nbsp;
        span {{quoteItems}}
    v-row
      v-col
        v-text-field(
          :value="instance.externalId",
          :label="$t('Quote.externalId')",
          disabled,
        )
      v-col
        v-text-field(
            v-model="instance.customerReference",
            :label="$t('Quote.customerReference')",
            :error-messages="errors['quote.customerReference']",
            :error="!!errors['quote.customerReference']",
        )
      v-col
        v-autocomplete(
            :label="$t('Quote.status')",
            :items="quoteStatuses",
            item-text="name",
            item-value="id",
            :loading="statusLoading",
            v-model="instance.statusId",
          )
      v-col
        v-autocomplete(
            :label="$t('Quote.rateCard')",
            :items="quoteRateCards",
            item-text="name",
            item-value="name",
            :loading="rateCardLoading",
            v-model="instance.rateCard",
            :error-messages="errors['quote.rateCard']",
          )

      v-col
        v-autocomplete(
            :label="$t('Quote.currency')",
            :items="currencies",
            :item-text="currencyDisplayText",
            item-value="code",
            :loading="currencyLoading",
            v-model="instance.currency",
            :error-messages="errors['quote.currency']",
          )
  .entity-content.px-5.py-0
    v-row
      v-col(cols="3")
        app-datetime-picker(
          :value="instance.createdAt",
          :label="$t('Quote.createdAt')",
          disabled,
        )
      v-col(cols="3")
        v-text-field(
            :label="$t('Quote.userFullName')",
            :value="(instance.user || {}).fullName",
            disabled,
        )
</template>

<style lang="scss" scoped>
  .header-text {
      font-weight: 600;
  }
</style>

<script>
import EntityMixin from '@/mixins';
import EntitiesMixin from '@/mixins/entities.mixin';
import axios from 'axios';

export default {
  mixins: [EntityMixin,EntitiesMixin],
  props: {
    slotProps: null,
    loading: null,
    uid: null,
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    quoteStatuses: [],
    statusLoading: true,
    quoteRateCards: [],
    rateCardLoading: true,
    currencies: [],
    currencyLoading: true,
  }),
  computed: {
      quoteTotal() {
        return `${this.currencySymbol}${this.grandTotal} ${this.instance.currency || ""}`;
      },
      quoteItems() {
        return this.instance.quoteItems ? this.instance.quoteItems.length : 0;
      },
      grandTotal() {
        let grandT = 0;
        for(var i=0; this.instance.quoteItems && i < this.instance.quoteItems.length; i++)
        {
            grandT = grandT + Number(this.instance.quoteItems[i].subtotalSell);
        }

        this.instance.quoteTotal = Number(grandT).toFixed(2);
        return this.instance.quoteTotal;
      },
      currencySymbol() {
        let selectedCurrency = this.currencies.find(c => c.code === this.instance.currency);
        return selectedCurrency ? selectedCurrency.symbolNative : '';
      },
  },
  methods: {
    async loadStatuses(){
        try{
            this.statusLoading = true;
            this.quoteStatuses = (await axios.get('Status?where[]=entity="Quote"', {params: { pageSize: -1 }})).data.data;
        } catch(error) {
            console.log(this.$cleanString(error));
        }finally {
            this.statusLoading = false;
        }
    },
    async loadRateCards(){
        try{
            this.rateCardLoading = true;
            this.quoteRateCards = (await axios.get('RateCard', {params: { pageSize: -1 }})).data.data;
        } catch(error) {
            console.log(this.$cleanString(error));
        }finally {
            this.rateCardLoading = false;
        }
    },
    async initializeCurrencies() {
      this.currencyLoading = true;
      this.currencies = await this.loadCurrencies();
      this.currencyLoading = false;
    },
  },
  async created() {
    this.loadStatuses();
    this.loadRateCards();
    this.initializeCurrencies();
  },
}
</script>
